<template>
    <div class="page">
        <div class="intro">
            <h1>About</h1>
        </div>
        <p>Growing up in Phoenix, I equally enjoyed being outside in the Arizona sunshine or inside curled up with a book. Art in all forms inspired me: literature, performing arts, visual design, you name it.<br><br>I received a Bachelor of Arts degree in Psychology from Arizona State University in 2005 and studied abroad in Spain that summer.<br><br>After graduating, I moved to Hollywood to experience the artistic culture and potential to see what career paths were out there. I still had a passion for literature but since there were no major book publishing companies in Los Angeles, I decided to go back to school to become a secondary English teacher.<br><br>I completed a Master of Arts degree in Educational Leadership from North Central University. Then, after eight years of teaching secondary education, I was ready for the next challenge.<br><br>In 2015, I started my new career path as a corporate sales trainer at Dish Network. As I got further into the role, I wanted to be a part of enhancing the training materials since I had a background in instructional design and education.<br><br>I collaborated with the Learning & Design team to create a structure for consistency so training materials could be well facilitated. The initiative and creative ideas I showed during those months was noticed. The National Training Manager asked me if I would join his team to train sales trainers at all sites around the world.<br><br>As I grew in my new role as a National Trainer, I had the opportunity to shadow the Design team for a week and knew this would be the next step in my career. I enrolled in an intensive course at Thinkful to begin a career as a UX Designer.<br><br>The past two years I have worked for EVOLVE, a startup company that focuses on construction software. I’ve worked with two other UX Designers to develop the look and feel of the product from the ground up. The product has already become a success and it continues to grow rapidly to meet the needs of the industry.<br><br>UX Design blends all of my passions and personality traits into one: self driven, independent, artistic, and passionate about designing to meet people’s needs.</p>
    </div>
</template>

<script>
    export default {
        name: 'About',
    }
</script>

<style scoped>
    .intro{
        text-align: center;
        font-weight: 700;
        margin-top: 50px;
        padding: 0px 30px;
        box-sizing: border-box;
    }

    h1{
        font-size: 3em; 
        font-weight: 500;
    }

    p{
        padding: 30px;
        box-sizing: border-box;
        text-align: left;
        max-width: 1000px;
        margin: 20px auto;
        line-height: 30px;
    }
  

    @keyframes animateleft{from{left:-300px;opacity:0} to{left:0;opacity:1}}

    @media only screen and (max-width: 700px){
            h1{
                font-size: 2em;
            }
    }
</style>
